export default "__VITE_ASSET__wVU2MWTC__"